// src/components/reports/precon-report-builder/prefill-precon-date.ts
import { format, parseISO } from "date-fns";
import type { DerivedSection } from "./derive-precon-sections";

/**
 * Prefill a section's Pre-con date from the earliest `taken_at` across all its
 * photos (located + unpinned), formatted to ISO `yyyy-MM-dd` for the date input.
 * Photos with a null/unparseable `taken_at` are skipped; returns "" if none
 * yield a usable date. Re-derived per selection — never read from the draft.
 */
export function prefillPreconDate(section: DerivedSection): string {
  let earliest = "";
  for (const photo of [...section.located, ...section.unpinned]) {
    const raw = photo.taken_at;
    if (!raw) continue;
    if (earliest === "" || raw < earliest) earliest = raw;
  }
  if (earliest === "") return "";
  try {
    return format(parseISO(earliest), "yyyy-MM-dd");
  } catch {
    return "";
  }
}
